import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('financingProductRules', {
  customKeys: {
    list: 'financing_product_rules',
  },
  customEndpoints: {
    delete: '/financing_product_rules/:id/deactivate',
  },
  customMethods: {
    delete: 'get',
  },
});
